import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '@/views/UserDashboard.vue'
import Product from '@/views/Product.vue'
import Transaction from '@/views/Transaction.vue'
import Investment from '@/views/Investment.vue'
import Wallet from '@/views/Wallet.vue'
import Login from '@/views/Login.vue'
import Profile from '@/views/Profile.vue'
import ProductDetail from '@/views/ProductDetails.vue'
import Portfolio from '@/views/Portfolio.vue'
import Settings from '@/views/Settings.vue'
import Signup from '@/views/Signup.vue'
import Forget from '@/views/Forget.vue'
import Username from '@/views/Username.vue'
import Createpin from '@/views/Createpin.vue'
import Reset from '@/views/Reset.vue'
import Newpassword from '@/views/Newpassword.vue'
import Verify from '@/views/Verify.vue'
import Summary from '@/views/Summary.vue'
import Referral from '@/views/Referral.vue'
import TwoFactor from '@/views/TwoFactor.vue' 
import Opportunity from '@/views/Opportunity.vue'

const routes = [
    {
        path: '/',
        redirect: "/dashboard",
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, title: 'Dashboard' },  //checks if a user is logged in before allowing them in
    },
    {
        path: '/products/:id',
        name: 'Products',
        component: Product,
        meta: { requiresAuth: true, title: 'Products' },
    },
    {
        path: "/product-detail/:slug",
        name: "ProductDetails",
        component: ProductDetail,
        meta: { requiresAuth: true, title: 'Details' },
    },
    {
        path: '/transactions',
        name: 'Transactions',
        component: Transaction,
        meta: { requiresAuth: true, title: 'Transactions' },
    },
    {
        path: '/investments',
        name: 'Investments',
        component: Investment,
        meta: { requiresAuth: true, title: 'Investments' },
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: Portfolio,
        meta: { requiresAuth: true, title: 'Portfolio' },
    },
    {
        path: '/summary/:id',
        name: 'Summary',
        component: Summary,
        meta: { requiresAuth: true, title: 'Summary' },
    },
    {
        path: '/opportunities',
        name: 'Opportunities',
        component: Opportunity,
        meta: { requiresAuth: true, title: 'Opportunity' },
    },
    {
        path: '/wallets',
        name: 'Wallets',
        component: Wallet,
        meta: { requiresAuth: true, title: 'Wallets' },
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: { requiresAuth: true, title: 'Profile' },
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: { requiresAuth: true, title: 'Settings' },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { guestOnly: true }, //prevents logged in user from going back to login
    },
    {
        path: '/signup',
        name: 'Signup',
        component: Signup,
        meta: { guestOnly: true }, 
    },
    {
        path: '/verify-email',
        name: 'Verify',
        component: Verify,
        meta: { guestOnly: true }, 
    },
    {
        path: '/forget-password',
        name: 'Forget',
        component: Forget,
        meta: { guestOnly: true }, 
    },
    {
        path: '/add-username',
        name: 'AddUsername',
        component: Username,
        meta: { guestOnly: true }, 
    },
    {
        path: '/create-pin',
        name: 'Createpin',
        component: Createpin,
        meta: { guestOnly: true }, 
    },
    {
        path: '/reset',
        name: 'Reset',
        component: Reset,
        meta: { guestOnly: true }, 
    },
    {
        path: '/referral',
        name: 'Referral',
        component: Referral,
        meta: { requiresAuth: true, title: 'Referral' },
    },
    {
        path: '/set-new-password',
        name: 'Newpassword',
        component: Newpassword,
        meta: { guestOnly: true }, 
    },
    {
        path: '/two-factor',
        name: 'TwoFactor',
        component: TwoFactor,
        meta: { guestOnly: true }, 
    }
    // add more routes here
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.meta.requiresAuth && !token) {
    next({ name: "Login" });
  }
  else if (to.meta.guestOnly && token) {
    next({ name: "Dashboard" });
  }
   else {
    next();
  }
});

export default router
